"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var useEditableField_1 = require("@features/ItemCommon/hooks/useEditableField");
var ConfirmRevertButtons_1 = __importDefault(require("@components/ConfirmRevertButtons"));
var react_i18next_1 = require("react-i18next");
var CopyIcon_1 = __importDefault(require("@components/CopyIcon"));
var QuickAddToList_1 = __importDefault(require("@components/QuickAddToList"));
var clickOutsideHook_1 = require("@common/hooks/clickOutsideHook");
var overflow_1 = require("@utils/overflow");
function Username(_a) {
    var isNotEditable = _a.isNotEditable, value = _a.value, setValue = _a.setValue, angularJsDependencies = _a.angularJsDependencies, domain = _a.domain, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    var containerRef = (0, react_1.useRef)(null);
    var valueRef = (0, react_1.useRef)(null);
    var _b = (0, useEditableField_1.useEditableField)(value, isNotEditable, setValue), mode = _b.mode, handleClick = _b.handleClick, onClickOutside = _b.onClickOutside, handleKeyDown = _b.handleKeyDown, resetToOriginalValue = _b.resetToOriginalValue, confirmChanges = _b.confirmChanges, tempValue = _b.tempValue, setTempValue = _b.setTempValue;
    (0, clickOutsideHook_1.useClickOutside)(containerRef, onClickOutside, [tempValue]);
    var classes = (0, clsx_1.default)({
        'item-detail-field': isNotEditable,
        'item-detail-field-edit': !isNotEditable,
    });
    return (react_1.default.createElement("div", { className: classes, "data-cy": "job-username" },
        react_1.default.createElement("div", { className: "item-detail-field__label" }, t('ITEM.USER_NAME')),
        mode === 'VIEW' && (react_1.default.createElement("div", { className: "item-detail-field-value-container", onClick: function (event) {
                handleClick();
                event.stopPropagation();
            } },
            react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", className: "item-detail-field__value-link-internal", ref: valueRef, title: (0, overflow_1.isTextOverflowing)(valueRef.current) ? value : undefined, href: angularJsDependencies.href('app.assignment.search', {
                    filters: encodeURIComponent("document.user.name:".concat(value)),
                    cursor: null,
                }), "data-cy": "job-username-value" }, value),
            react_1.default.createElement("div", { className: "eva-job-key-value-item__icon-container", onClick: function (event) { return event.stopPropagation(); } },
                react_1.default.createElement(CopyIcon_1.default, { value: value }),
                react_1.default.createElement(QuickAddToList_1.default, { domain: domain, word: value, label: t('ITEM.USER_NAME'), automationListsPermission: automationListsPermission })))),
        mode === 'EDIT' && (react_1.default.createElement("div", { className: "edit-input", ref: containerRef },
            react_1.default.createElement("input", { "data-cy": "job-username-input", className: "form-control inputs-should-respond-to-keyboard-arrows eva-text-box-component__input", onChange: function (e) { return setTempValue(e.currentTarget.value); }, value: tempValue || '', onKeyDown: handleKeyDown, 
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true }),
            react_1.default.createElement(ConfirmRevertButtons_1.default, { name: "job-username-button", onConfirmClicked: function () {
                    confirmChanges(tempValue || '');
                }, onRevertClicked: resetToOriginalValue })))));
}
exports.default = Username;
